module.exports = __webpack_public_path__ + "img/bs.f92494b7.svg";